import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

import { Link } from '@lt/components';
import { useTranslation } from '@lt/localization';

interface OperatorDetailsProps {
  className?: string;
  operatorName?: string;
  bookingUrl: string | null;
  isLoggedUser?: boolean;
}

export const OperatorDetails: FC<OperatorDetailsProps> = ({
  className,
  operatorName,
  bookingUrl,
  isLoggedUser,
}) => {
  const { t } = useTranslation();

  return operatorName && bookingUrl ? (
    <BookingLink
      as={isLoggedUser ? Link : 'span'}
      href={bookingUrl}
      className={className}
    >
      {t('checkout.packageInfo.operatorDetails')} {operatorName}
    </BookingLink>
  ) : null;
};

const BookingLink = styled.span`
  display: block;
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
  color: #17181a;
  margin-top: 4px;
`;
